import React from "react";
import styled from "@emotion/styled";
import TitleWithIcon from "./TitleWithIcon";

const Container = styled("div")(({ noMargin, noBorder }) => ({
  boxSizing: "border-box",
  borderRadius: 8,
  border: noBorder ? "none" : "1px solid #EBEDED",
  padding: noBorder ? "16px 0 12px" : "16px 16px 12px",
  marginBottom: noMargin ? 0 : 18,
  width: "100%",
  wordBreak: "break-word",
  hyphens: "auto",
}));
/**
 * Card Component
 * @param {string} title
 * @param {string} [icon]
 * @param {string} [id=""]
 * @param {"bold" | "normal"} [size="normal"]
 * @param {boolean} [noContentPadding=false]
 * @param {boolean} [noMargin=false]
 * @param {boolean} [noBorder=false]
 * @param {string} [extraContentClass=""]
 * @param {React.ReactNode} [children]
 * @param {string} [htmlContent=""]
 */
export default function Card({
  title,
  icon,
  size = "normal",
  children,
  htmlContent = "",
  extraContentClass = "",
  noContentPadding = false,
  noMargin = false,
  noBorder = false,
  id = "",
}) {
  const renderContent = () => {
    if (htmlContent) {
      return (
        <div
          className={`r_additionalText ${extraContentClass}`}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          {...(noContentPadding && { style: { paddingLeft: 0 } })}
        />
      );
    }
    return (
      <div>
        <p
          className={`r_additionalText ${extraContentClass}`}
          {...(noContentPadding && { style: { paddingLeft: 0 } })}
        >
          {children}
        </p>
      </div>
    );
  };

  return (
    <Container id={id} noMargin={noMargin} noBorder={noBorder}>
      <TitleWithIcon text={title} icon={icon} size={size} />
      {renderContent()}
    </Container>
  );
}
